var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"l-icon",style:({ width: _vm.width, height: _vm.height }),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('use',{attrs:{"xlink:href":("#icon-" + _vm.name),"fill":_vm.color}})])}
var staticRenderFns = []

export { render, staticRenderFns }